import React from 'react';
import styled from 'styled-components';
import { Fade } from 'react-awesome-reveal';
import ofp1 from "../Images/ofp1.png"
import ofp2 from "../Images/ofp2.png"

// --- STYLED COMPONENTS ---

const ArticleContainer = styled.article`
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  max-width: 900px;
  margin: 0 auto;
  padding: 10px 20px;
  color: #333333;
  line-height: 1.1;
`;

const ContentCard = styled.div`
  background-color: #ffffff;
//   padding: 50px;
  border-radius: 8px;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 2px 4px -1px rgba(0, 0, 0, 0.03);

  @media (max-width: 640px) {
    // padding: 25px 20px;
  }
`;

const MainTitle = styled.h1`
  font-size: 2.4rem;
  font-weight: 700;
  color: #439E6D; /* Corporate dark navy */
  text-transform: uppercase;
//   margin: 0 0 15px 0;
  letter-spacing: -0.5px;
`;

const MetaInfo = styled.div`
  font-size: 1.1rem;
  font-weight: 600;
  color: #439E6D; /* Your signature theme accent color */
//   margin-bottom: 35px;
  
  span {
    color: #64748b;
    font-weight: normal;
  }
`;

const SectionIntro = styled.p`
  font-size: 1.1rem;
  color: #334155;
  margin-bottom: 10px;
`;

const SectionSubheading = styled.h2`
  font-size: 1.15rem;
  font-weight: 700;
  color: #0c2340;
  text-transform: uppercase;
//   margin: 30px 0 20px 0;
  letter-spacing: 0.5px;
`;

const SubheadingIntro = styled.p`
  font-size: 1.1rem;
  color: #4a5568;
//   margin-bottom: 30px;
`;

// Segment Point wrapper mimicking the layout list style
const PointSegment = styled.div`
//   margin-bottom: 40px;
  position: relative;
  padding-left: 25px;

  &::before {
    content: "▪"; /* Square point marker matching image style */
    color: #0c2340;
    font-size: 1.1rem;
    position: absolute;
    left: 2px;
    top: 2px;
  }
`;

const PointHeader = styled.h3`
  font-size: 1.1rem;
  font-weight: 600;
  color: #4a5568;
//   margin: 0 0 20px 0;
`;

// Image Placeholder matching the card container blocks
const InlineImageSlot = styled.div`
  width: 100%;
  max-width: 600px;
  height: 340px;
  background-color: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
//   margin: 20px 0 25px 0;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  span {
    color: #94a3b8;
    font-size: 1.1rem;
  }
`;

const BlockParagraph = styled.p`
  font-size: 1.1rem;
  color: #4a5568;
  text-align: justify;
  margin-bottom: 10px;
  line-height: 1.6;
`;

const ServiceListIntro = styled.p`
  font-size: 1.1rem;
  font-weight: 600;
  color: #0c2340;
  margin: 10px 0 15px 0;
`;

const SimpleBulletList = styled.ul`
  list-style-type: none;
  padding-left: 0;
  margin-bottom: 10px;
`;

const SimpleBulletItem = styled.li`
  font-size: 0.98rem;
  color: #4a5568;
  margin-bottom: 12px;
  position: relative;
  padding-left: 25px;

  &::before {
    content: "▪";
    color: #439E6D; /* Branding color matched bullet square */
    font-size: 0.9rem;
    position: absolute;
    left: 2px;
    top: 1px;
  }
`;

// --- MAIN COMPONENT ---

const OffshoreSurveysArticle = () => {
  return (
    <ArticleContainer>
      <Fade triggerOnce direction="up" duration={800}>
        <ContentCard>
          
          {/* Main Document Header */}
          <MainTitle>OFFSHORE SURVEYS</MainTitle>
          <MetaInfo>
            By admin <span>/ May 14, 2024</span>
          </MetaInfo>

          <SectionIntro>
            We have a dedicated team for land surveys and the range services include/
          </SectionIntro>

          <SectionSubheading>OFFSHORE SURVEYS</SectionSubheading>
          <SubheadingIntro>
            We offer precise positioning for clients offshore assets and our range of offshore services include:
          </SubheadingIntro>

          {/* Point 1: Real-time surface navigation */}
          <PointSegment>
            <PointHeader>Real-time surface navigation and positioning for Rigs, vessels and barges</PointHeader>
            
            <InlineImageSlot>
              <img src={ofp1} onError={(e) => e.target.style.display='none'} />
              {/* <span>[ Offshore Navigation Image Space ]</span> */}
            </InlineImageSlot>

            <BlockParagraph>
              Modern positioning techniques have always been necessary for the offshore exploration and exploitation of natural resources, and this has led to the development of specialized tools and offerings. This study examines the offshore exploration and production activities that necessitate positioning or navigation and lists the typical accuracy requirements for each of them. After that, it goes into greater detail about some of the trickiest or most complicated processes, outlining the methods employed and outlining the financial and technological risks. We emphasize the unique characteristics of the offshore sector.
            </BlockParagraph>
          </PointSegment>

          {/* Point 2: Debris/hazard surveys */}
          <PointSegment>
            <PointHeader>Debris/hazard surveys of future sites for development and construction</PointHeader>
            <BlockParagraph>
              When precipitation and/or glacial runoff coexist with steep topography, one of the most common mass movement phenomena is debris flows, which are gravity-driven, fast mass movements of soil, rock, and water. Their high degree of runout, rapid flow velocity, and impact loading potential make them among the most dangerous landslide kinds due to their combination with ambiguity around their temporal and spatial occurrence (Legros, 2002).
            </BlockParagraph>
            <BlockParagraph>
              Since the May 2005 tragedy that destroyed or severely damaged 114 dwellings at Matata in the Bay of Plenty, people in New Zealand have become more aware of the potential for damage from debris flows (McSaveney et al. 2005). Additionally, the growing habitation of formerly “marginal” land, especially in areas of outstanding natural beauty.
            </BlockParagraph>
          </PointSegment>

          {/* Point 3: Under water precise positioning */}
          <PointSegment>
            <PointHeader>Under water precise positioning</PointHeader>
            <BlockParagraph>
              Precise position data collecting for underwater vehicle navigation services, underwater fault displacement monitoring, underwater engineering, and other applications depends heavily on underwater acoustic positioning (Kussat et al., 2005; Sato et al., 2013; Watanabe et al., 2015). The three main techniques for underwater positioning are ultra-short baseline (USBL), short baseline (SBL), and long baseline (LBL). Of these, LBL is the most important method for precisely determining the underwater position of an unmanned underwater vehicle (UUV) (Almeida et al., 2016). The necessary precondition for high-precision UUV position is high-precision transponder positioning. Global navigation satellite systems (GNSS) and underwater acoustic equipment are currently used to conduct high-precision placement of single transponders. Distance rendezvous is then used to calculate the fixed transponder's three-dimensional coordinates (Alcocer).
            </BlockParagraph>
          </PointSegment>

          {/* Point 4: Barge/Tug management Systems */}
          <PointSegment>
            <PointHeader>Barge/Tug management Systems for rigs, jackets and other marine construction and installations</PointHeader>
          </PointSegment>

          {/* NEW SECTION ADDED FROM FILE: image_c0297f.png */}
          <PointSegment>
            <PointHeader>Offshore geophysical survey</PointHeader>
            
            <InlineImageSlot>
              <img src={ofp2} onError={(e) => e.target.style.display='none'} />
              {/* <span>[ Offshore Geophysical Image Space ]</span> */}
            </InlineImageSlot>

            <BlockParagraph>
              A continuous model is provided by geophysical surveys to support the geologic data obtained from geotechnical information. A geotechnical core offers a plethora of knowledge regarding the project ground's geology. But it is like seeing through a keyhole to examine what's below the surface. This sample is authentic; it accurately depicts the stratigraphy that lies beneath the seafloor at that particular place. A more continuous ground model can be created by fusing the geophysical modeling with the geologic truthing of the core results. Plans are subject to alter for a number of reasons, and moving a turbine is a very expensive strategy. The availability of geophysical survey data that is appropriately correlated with the geotechnical studies permits a broad range of flexibility in the analytic of subsurface changes.
            </BlockParagraph>
          </PointSegment>

          {/* Additional bottom options bullet layout */}
          <Fade triggerOnce direction="up" duration={700} delay={100}>
            <ServiceListIntro>Our Other Offshore Survey services include:</ServiceListIntro>
            <SimpleBulletList>
              <SimpleBulletItem>Offshore geotechnical surveys</SimpleBulletItem>
              <SimpleBulletItem>ROV inspection services</SimpleBulletItem>
            </SimpleBulletList>
          </Fade>

        </ContentCard>
      </Fade>
    </ArticleContainer>
  );
};

export default OffshoreSurveysArticle;